import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box } from "@mui/material";
import { Layout, Menu, MenuProps, theme, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loginState, mobileState, WHState } from "../Atom/AtomState";
import MenuData from "../Data/MenuData";
import { localStorageBase64 } from "../Atom/localStorageBase64";

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

type LayoutProps = {
  children: React.ReactNode;
  Sidebar: boolean;
  setSidebar: (value: boolean) => void;
};

const LayoutDegign: React.FC<LayoutProps> = ({
  children,
  Sidebar,
  setSidebar,
}) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  let navigate = useNavigate();
  const [LoginState, setLoginState] = useRecoilState(loginState);
  const WH = useRecoilValue(WHState);
  const MobileState = useRecoilValue(mobileState);
  const [menu, setMenu] = useState<string>(
    window.location.pathname.replace("/", "")
  );

  const onMenu: MenuProps["onClick"] = (e) => {
    if (e.key == "logout") {
      setLoginState(null);
      localStorageBase64().clear();
      navigate("/");
    } else {
      navigate(e.key);
    }
  };

  const subMenu = () => {
    if (menu == "MemberDetailPage") {
      return "MemberPage";
    } else if (menu == "QuestionDetailPage") {
      return "QuestionPage";
    } else if (menu == "NoticeDetailPage") {
      return "NoticePage";
    } else if (menu == "ConsultDetailPage") {
      return "ConsultPage";
    } else {
      return menu;
    }
  };

  useEffect(() => {
    setMenu(window.location.pathname.replace("/", ""));
  });

  return window.location.pathname.toLowerCase() == "/customer" ||
    !LoginState ? (
    <div>{children}</div>
  ) : (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0px  20px",
          width: WH.width,
        }}
      >
        <Title
          level={WH.width > 768 ? 3 : 4}
          style={{ color: "#ffffff", margin: "0px 10px" }}
        >
          {MobileState ? (
            <Box style={{ display: "flex", alignItems: "center" }}>
              {Sidebar == true ? (
                <MenuIcon
                  style={{ marginRight: "10px" }}
                  onClick={() => setSidebar(!Sidebar)}
                />
              ) : (
                <MenuOpenIcon
                  style={{ marginRight: "10px" }}
                  onClick={() => setSidebar(!Sidebar)}
                />
              )}
              Ocollor consult result
            </Box>
          ) : (
            "Ocollor consult result"
          )}
        </Title>
      </Header>
      <Layout>
        {Sidebar && (
          <Sider width={220} style={{ background: colorBgContainer }}>
            <Menu
              mode="inline"
              selectedKeys={[subMenu()]}
              style={{ height: "100%", borderRight: 0 }}
              items={
                LoginState?.manager
                  ? MenuData()
                  : MenuData().filter(
                      (item: any) =>
                        item.key != "MemberPage" &&
                        item.key != "QuestionPage" &&
                        item.key != "NoticePage"
                    )
              }
              onClick={onMenu}
            />
          </Sider>
        )}

        <Layout
          style={{
            padding: "24px",
            width: Sidebar ? WH.width - 180 : WH.width,
          }}
        >
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default LayoutDegign;
